import { Component } from "@angular/core";
import { CustomModal } from "../../../core/components/base-modals";

@Component({
	templateUrl: "./cashplus-current-rate-info-modal.component.html",
	styleUrls: ["./cashplus-current-rate-info-modal.component.scss"],
	standalone: false
})
export class CashplusCurrentRateInfoModalComponent extends CustomModal {}
